import { isSodimacStandalone, isWhitelabel } from '@digital-retail/store-manager';
import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import icons from '../../../../../config/styles/icons';

import AdditionalPDPLabel from '../../../../../components/AdditionalPDPLabel/v2';
import Availability from '../../../../../components/Availability/Availability';
import { AvailabilityLocation } from '../../../../../components/Availability/AvailabilityLocation/AvailabilityLocation';
import { getZoneName } from '../../../../../components/Availability/DeliveryOptions/DeliveryOptions.Helper';
import CMRApertura from '../../../../../components/CMRApertura/CMRApertura';
import CMRCalculatorDesktop from '../../../../../components/CMRCalculator/Desktop';
import Fomo from '../../../../../components/Fomo/Fomo';
import InstallmentsWithoutInterest from '../../../../../components/InstallmentsWithoutInterest/InstallmentsWithoutInterest';
import InternationalShipping from '../../../../../components/InternationalShipping/v2';
import MultipurposeBadge from '../../../../../components/MultipurposeBadge/MultipurposeBadge';
import Operator from '../../../../../components/Operator/Operator';
import { VariantId } from '../../../../../components/PDP';
import ProductColorSwatches from '../../../../../components/ProductColorSwatches/ProductColorSwatches';
import ProductPrices from '../../../../../components/ProductPrices/ProductPrices';
import ProductServices from '../../../../../components/ProductServices/ProductServices';
import ProductTopSpecifications from '../../../../../components/ProductTopSpecifications/v2';
import { ReaconditionedContainer } from '../../../../../components/ReaconditionedContainer/v2';
import Size from '../../../../../components/Size/Size';
import StockQuantity from '../../../../../components/StockQuantity/StockQuantity';
import BodyCopy from '../../../../../components/ui/BodyCopy/BodyCopy';
import Button from '../../../../../components/ui/Button/Button';
import Divider from '../../../../../components/ui/Divider';
import StockTable from '../../../../../components/ui/StockTable/StockTable';
import Warranty from '../../../../../components/Warranty/v2';
import constants from '../../../../../config/constants';
import { withApplicationContext } from '../../../../../utils/ApplicationContext';
import { CookieStorage } from '../../../../../utils/CookieStorage';
import { useUserSegments } from '../../../../../utils/hooks/useUserSegments';
import { withLabels } from '../../../../../utils/LabelsContext';
import _ from '../../../../../utils/LodashImports';
import { noop } from '../../../../../utils/noop';
import {
  getPriceForOutOfStock,
  getSizeSelectionLabel,
  isConnectProduct,
  isReaconditionedProduct,
} from '../../../../../utils/product/productUtils';
import { withProduct } from '../../../../../utils/ProductContext';
import { getVariant } from '../../../../../utils/variant';
import { SKUIdSeller } from '../../../../common/PDPBasicInfoShared';
import ProductQuantitySelectionContainer from '../../../Hardline/Desktop/ProductQuantitySelectionContainer/v2';
import { ProductSpecificationsDesktopStyle } from './style';

const ProductSpecificationsDesktop = ({
  product,
  labels,
  appCtx,
  isPumAvailable,
  pumQuantity,
  primeShipping,
  colorVariants,
  selectedColorSwatchIndex,
  colorSwatchHandler,
  sizes,
  selectedSize,
  sizeChangeHandler,
  handleAddToCart,
  isAddToCartInProgress,
  operatorChangeHandler,
  operators,
  setServiceOption,
  selectedOperatorId,
  handleRemoveFromCart,
  isRemoveFromCartInProgress,
  addToCartButtonVisible,
  showCollectionButtonVisible,
  isVendorLogin,
  storeSkuData,
  currentTab,
  errorAddingToCart,
  requestProductFromStore,
  setShowLoginForm,
  showLoginForm,
  setErrorAddingToCart,
  sizeChartData,
  fomo,
  variantSwatchType,
  setWarrantyOption,
  userSegments,
}) => {
  const { regionCode, store, siteConfig, comuna: comunaData, isDefaultComuna } = appCtx || {};
  const { MAX_CART_PRODUCT, FIRST_PARTY_SELLER_REGEX, DEVICE_DESKTOP, PRODUCT_CONSTANTS } = constants;
  const { CMR_INSTALLMENT_ERROR_MESSAGE, COLOR, SEE_COLLECTION_BUTTON_LABEL, PDP_STARTS_FROM } = labels;
  const { textDictionary, toggles } = siteConfig;
  const { getCookie, unescapeCookies } = CookieStorage;
  const dynDataCookie = unescapeCookies(getCookie('sid'));
  const isUserLoggedIn = !!dynDataCookie;
  const { currentUserSegments } = useUserSegments(regionCode, userSegments, isUserLoggedIn, store);

  const {
    id: productId,
    currentVariant: currentVariantId,
    variants,
    additionalPDPLabels,
    isOutOfStock,
    colorMetrics,
    cmrBannerActive = true,
    darSectionActive = false,
    serviceOptions,
    attributes,
    warrantyOptions,
    sizeChartTable,
    brandLogoUrl,
  } = product;

  const {
    badges = [],
    meatStickers = [],
    promotions,
    prices,
    cmrPoints,
    discountBadge,
    cmrSavings,
    maxOnCartAmount: maxCartQuantity = MAX_CART_PRODUCT,
    multipurposeBadges = [],
    offerings = [],
  } = getVariant(variants, currentVariantId);

  const { pumUnits } = attributes;

  const fomoMessage = _.get(textDictionary, 'FOMO_MESSAGE', 'Últimas unidades');
  const allowed3PCampaignNamesToRender = _.get(
    textDictionary,
    'ALLOWED_3P_CAMPAIGN_NAMES_TO_RENDER',
    'ENVIO GRATIS 3P, ENVIO_GRATIS_3P'
  );

  const {
    isCMRAperturaEnabled = false,
    isMultipurposeBadgeApplicable = false,
    isMeatStickerApplicableInPDP = false,
    isInternationalBuyVisiblePDP = false,
    isStoreAvailabilityVisibleInPDP = false,
    isCMRCalculatorEnabledPDP = false,
    isWarrantyTooltipEnabled = false,
  } = toggles;

  const freeShippingPromotionFor3p = promotions?.find((promotion) =>
    allowed3PCampaignNamesToRender
      .split(',')
      .map((name) => name.trim())
      .includes(promotion.campaignName)
  );
  const nonEventMeatStickers = (meatStickers || []).filter((sticker) => !['event'].includes(sticker.type));
  const sellerName = _.get(variants, '[0].offerings[0].sellerName', '');
  const is1pSeller = FIRST_PARTY_SELLER_REGEX.test(sellerName.toLowerCase());
  const hasNoVariants = sizes.length === 0;
  const fomoEnabled = fomo?.enabled ?? false;
  const connectProduct = isConnectProduct(product);
  const isStoreDataVaild = storeSkuData && Object.keys(storeSkuData).length > 0;
  const isSoCom = isSodimacStandalone(store);

  const addToCartLabel = _.get(additionalPDPLabels, 'addToCart.enabled', false)
    ? _.get(additionalPDPLabels, 'addToCart', {})
    : null;

  const isReaconditionedProd = isReaconditionedProduct(product);
  const isWhitelabelSite = isWhitelabel({ store });

  const additionalWarrantyLabel = _.get(additionalPDPLabels, 'warranty.enabled', false)
    ? _.get(additionalPDPLabels, 'warranty', {})
    : null;

  const selectedZone = comunaData?.data || null;
  const defaultZoneConfig =
    selectedZone && !_.isEmpty(selectedZone)
      ? selectedZone
      : {
          region: {},
          comuna: {},
        };

  const [zoneConfig, setZoneConfig] = useState(defaultZoneConfig);

  const { comunaName } = getZoneName(selectedZone, isDefaultComuna) || { comunaName: '' };

  useEffect(() => {
    if (selectedZone && !isDefaultComuna) setZoneConfig({ ...selectedZone });
  }, [selectedZone]);

  if (isOutOfStock) {
    return (
      <div
        className="product-specifications"
        data-backend-category={product.merchantCategoryId}
        data-availability={product.attributes && product.attributes.isPrimeAvailable}
        data-published={product.isPublished}
        data-variations={variants.length}
      >
        <div className="product-specifications-column fa--product-specifications-column__desktop">
          {prices && prices.length > 0 && (
            <div className="prices-container">
              <div className="prices">
                <ProductPrices
                  isVendorLogin={isVendorLogin}
                  currentTab={currentTab}
                  storeSkuData={storeSkuData}
                  prices={getPriceForOutOfStock(prices)}
                  productId={productId}
                  regionCode={regionCode}
                  cmrPoints={cmrPoints}
                  pumUnit={pumUnits}
                  isPumAvailable={isPumAvailable}
                  pumQuantity={pumQuantity}
                  primeShipping={primeShipping}
                  deviceType={DEVICE_DESKTOP}
                />
                {hasNoVariants && fomoEnabled && <Fomo text={fomoMessage} />}
              </div>
            </div>
          )}
          {isReaconditionedProd && <ReaconditionedContainer appCtx={appCtx} productAttributes={product} />}
        </div>
        <style jsx>{ProductSpecificationsDesktopStyle}</style>
      </div>
    );
  }
  const sizeSelectionLabel = getSizeSelectionLabel(product, labels.SELECTION_SIZE);

  return (
    <div
      className="product-specifications"
      data-backend-category={product.merchantCategoryId}
      data-availability={product.attributes && product.attributes.isPrimeAvailable}
      data-published={product.isPublished}
      data-variations={variants.length}
    >
      <div className="product-specifications-column fa--product-specifications-column__desktop">
        <StockQuantity />
        {colorVariants[selectedColorSwatchIndex] && (
          <div className="colorSwatches-container">
            <BodyCopy isHighlighted size="copy3">{`${COLOR}: `}</BodyCopy>
            <BodyCopy size="copy3">{colorVariants[selectedColorSwatchIndex].label}</BodyCopy>
            <ProductColorSwatches
              colorVariants={colorVariants}
              productId={product.id}
              selectedColorSwatchIndex={selectedColorSwatchIndex}
              colorSwatchHandler={colorSwatchHandler}
              type={PRODUCT_CONSTANTS.SOFTLINE}
              size="medium"
              appCtx={appCtx}
              colorMetrics={colorMetrics}
              variantSwatchType={variantSwatchType}
            />
          </div>
        )}
        {sizes.length !== 0 && (
          <div className="size-container mkp-softline-size">
            <Size
              title={sizeSelectionLabel}
              sizes={sizes}
              onSizeChange={sizeChangeHandler}
              selectedSize={selectedSize}
              isSoftline
              sizeChartData={sizeChartData}
              fomo={fomo}
              appCtx={appCtx}
              sizeChartTable={sizeChartTable}
              brandLogoUrl={brandLogoUrl}
            />
          </div>
        )}
        {prices && prices.length > 0 && (
          <div
            className={`prices-container
          ${isMultipurposeBadgeApplicable && multipurposeBadges.length > 0 ? 'withMultipurposeBadge' : ''}
          `}
          >
            <div className="prices">
              <ProductPrices
                isVendorLogin={isVendorLogin}
                currentTab={currentTab}
                storeSkuData={storeSkuData}
                prices={prices}
                productId={productId}
                regionCode={regionCode}
                cmrPoints={cmrPoints}
                pumUnit={pumUnits}
                isPumAvailable={isPumAvailable}
                pumQuantity={pumQuantity}
                primeShipping={primeShipping}
                deviceType={DEVICE_DESKTOP}
                discountBadge={discountBadge}
                darSectionActive={darSectionActive}
              />
            </div>
            {isCMRCalculatorEnabledPDP && (
              <div className="cmrCalculator-container">
                <CMRCalculatorDesktop errorMessage={CMR_INSTALLMENT_ERROR_MESSAGE} layout="softline" />
              </div>
            )}
          </div>
        )}

        <InstallmentsWithoutInterest
          appCtx={appCtx}
          product={product}
          userSegments={currentUserSegments}
          isUserLoggedIn={isUserLoggedIn}
          regionCode={regionCode}
        />

        {isMultipurposeBadgeApplicable && multipurposeBadges.length > 0 && (
          <div className="multipurpose-badge">
            <MultipurposeBadge badgeItems={multipurposeBadges} deviceType="desktop" inPdp />
          </div>
        )}

        {isVendorLogin && isStoreDataVaild && (
          <StockTable
            stockData={storeSkuData}
            colorVariants={colorVariants}
            selectedColorSwatchIndex={selectedColorSwatchIndex}
            sizes={sizes}
            requestProductFromStore={requestProductFromStore}
            regionCode={regionCode}
          />
        )}

        {connectProduct && (
          <Operator
            isDesktop
            isConnectProduct={connectProduct}
            operators={operators}
            operatorChangeHandler={operatorChangeHandler}
            selectedOperatorId={selectedOperatorId}
          />
        )}

        <ProductQuantitySelectionContainer
          errorAddingToCart={errorAddingToCart}
          addToCartButtonVisible={addToCartButtonVisible}
          isAddToCartInProgress={isAddToCartInProgress}
          labels={labels}
          maxCartQuantity={maxCartQuantity}
          handleAddToCart={handleAddToCart}
          handleRemoveFromCart={handleRemoveFromCart}
          isRemoveFromCartInProgress={isRemoveFromCartInProgress}
          isVendorLogin={isVendorLogin}
          sizes={sizes}
          selectedSize={selectedSize}
          setShowLoginForm={setShowLoginForm}
          showLoginForm={showLoginForm}
          setErrorAddingToCart={setErrorAddingToCart}
          layout="softline"
          appCtx={appCtx}
          product={product}
        />

        <ProductTopSpecifications scollToElementId="productSpecificationsAccordion" />

        <div className="additional-pdp-label-container">
          {addToCartLabel && (
            <AdditionalPDPLabel label={addToCartLabel} type="addToCart" productType="softline" desktop />
          )}
          {isReaconditionedProd && <ReaconditionedContainer appCtx={appCtx} productAttributes={product} />}
          {isInternationalBuyVisiblePDP && <InternationalShipping product={product} />}
          <div className="variant-id-seller">
            <span className="barcode-icon" dangerouslySetInnerHTML={{ __html: icons.barcode }} />
            <VariantId variantId={currentVariantId} labels={labels} isSoCom={isSoCom} />
            {SKUIdSeller({
              appCtx,
              offerings,
              labels,
              regionCode,
              product,
            })}
          </div>
        </div>

        <Divider variant="thin" />

        {!!product.showShippingModal && (
          <div className={cx('delivery-options-wrapper', isWhitelabelSite && 'whitelabel')}>
            {comunaName && (
              <div className="avl-content">
                <AvailabilityLocation comunaName={comunaName} />
              </div>
            )}
            <div className="dlv-opt-wrapper">
              <Availability
                isSoftline
                sizes={sizes}
                colorVariants={colorVariants}
                regionCode={regionCode}
                store={store}
                isStoreAvailabilityVisibleInPDP={isStoreAvailabilityVisibleInPDP}
                is1pSeller={is1pSeller}
                selectedZone={selectedZone}
                zoneConfig={zoneConfig}
                setZoneConfig={setZoneConfig}
                isDefaultComuna={isDefaultComuna}
                badgeItems={isMeatStickerApplicableInPDP ? nonEventMeatStickers : badges}
                promotionBadge={freeShippingPromotionFor3p?.badge}
              />
            </div>
          </div>
        )}

        {connectProduct && (
          <Warranty
            warrantyOptions={warrantyOptions}
            setWarrantyOption={setWarrantyOption}
            startsFromLabel={PDP_STARTS_FROM}
            tooltipToggle={isWarrantyTooltipEnabled}
            additionalWarrantyLabel={additionalWarrantyLabel}
            sellerName={sellerName}
          />
        )}

        <ProductServices serviceOptions={serviceOptions} setServiceOption={setServiceOption} />

        {showCollectionButtonVisible && (
          <div className="addToCart-container fa--add-to-cart__desktop">
            <Button type="outline" onClick={handleAddToCart} size="xtra-large">
              <span>
                {SEE_COLLECTION_BUTTON_LABEL}
                <i className="csicon-arrow_down_small" />
              </span>
            </Button>
          </div>
        )}
        {isCMRAperturaEnabled && cmrBannerActive && !isSoCom && (
          <CMRApertura prices={prices} cmrSavings={cmrSavings} isSoftline />
        )}
      </div>
      <style jsx>{ProductSpecificationsDesktopStyle}</style>
    </div>
  );
};

ProductSpecificationsDesktop.defaultProps = {
  isPumAvailable: false,
  pumQuantity: 0,
  primeShipping: false,
  colorVariants: [],
  selectedColorSwatchIndex: 0,
  colorSwatchHandler: noop,
  sizes: [],
  selectedSize: '',
  sizeChangeHandler: noop,
  handleAddToCart: noop,
  requestProductFromStore: noop,
  operatorChangeHandler: noop,
  operators: [],
  selectedOperatorId: '',
  setServiceOption: noop,
  isAddToCartInProgress: false,
  handleRemoveFromCart: noop,
  isRemoveFromCartInProgress: false,
  addToCartButtonVisible: true,
  showCollectionButtonVisible: false,
  storeSkuData: [],
  currentTab: undefined,
  errorAddingToCart: false,
  showLoginForm: false,
  sizeChartData: {},
  fomo: {},
  variantSwatchType: undefined,
  setWarrantyOption: noop,
  userSegments: [],
};

ProductSpecificationsDesktop.propTypes = {
  product: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  isPumAvailable: PropTypes.bool,
  pumQuantity: PropTypes.number,
  primeShipping: PropTypes.bool,
  colorVariants: PropTypes.array,
  selectedColorSwatchIndex: PropTypes.number,
  colorSwatchHandler: PropTypes.func,
  sizes: PropTypes.array,
  selectedSize: PropTypes.string,
  sizeChangeHandler: PropTypes.func,
  handleAddToCart: PropTypes.func,
  requestProductFromStore: PropTypes.func,
  operatorChangeHandler: PropTypes.func,
  operators: PropTypes.array,
  selectedOperatorId: PropTypes.string,
  setServiceOption: PropTypes.func,
  isAddToCartInProgress: PropTypes.bool,
  handleRemoveFromCart: PropTypes.func,
  isRemoveFromCartInProgress: PropTypes.bool,
  addToCartButtonVisible: PropTypes.bool,
  showCollectionButtonVisible: PropTypes.bool,
  isVendorLogin: PropTypes.bool.isRequired,
  storeSkuData: PropTypes.array,
  currentTab: PropTypes.string,
  errorAddingToCart: PropTypes.bool,
  setShowLoginForm: PropTypes.func.isRequired,
  setErrorAddingToCart: PropTypes.func.isRequired,
  showLoginForm: PropTypes.bool,
  sizeChartData: PropTypes.object,
  fomo: PropTypes.object,
  variantSwatchType: PropTypes.string,
  setWarrantyOption: PropTypes.func,
  userSegments: PropTypes.array,
};

export default withProduct(withLabels(withApplicationContext(ProductSpecificationsDesktop)));
